import React from "react";
import { Switch, Route } from "react-router-dom";
import routes from "constants/routes";
import AuthView from "views/auth/AuthView";
import EnrollmentView from "views/enrollment/EnrollmentView";
import StationView from "views/station/StationView";
import Providers from "./Providers";
import PrivateRoutes from "./PrivateRoutes";
import AdminView from "views/admin/AdminView";
import Jumping from "views/enrollment/Jumping";

const App: React.FC = () => (
  <Providers>
    <Switch>
      <Route exact path={routes.SIGN_IN} component={AuthView} />
      <Route exact path={routes.RESET_PASSWORD} component={AuthView} />
      <Route exact path={routes.REGISTER} component={AuthView} />
      <PrivateRoutes>
        <Switch>
          <Route exact path={routes.ENROLLMENT} component={EnrollmentView} />
          <Route exact path={routes.JUMPING} component={Jumping} />
          <Route path={routes.ADMIN} component={AdminView} />
          <Route component={StationView} />
        </Switch>
      </PrivateRoutes>
    </Switch>
  </Providers>
);

export default App;
